import { CalendarKind } from "./types";

export interface CalendarProviderOption {
  name: string;
  available: boolean;
  /** Backend `/connect?kind=` value. Omitted for placeholders with no API yet. */
  kind?: CalendarKind;
}

/** Providers shown on the connect picker. `available` is the live OAuth gate. */
export const CALENDAR_PROVIDERS: CalendarProviderOption[] = [
  { kind: "GOOGLE", name: "Google Calendar", available: true },
  { kind: "OUTLOOK", name: "Microsoft Outlook", available: false },
  { name: "Apple Calendar", available: false },
];

export function calendarProviderName(kind: CalendarKind): string {
  return (
    CALENDAR_PROVIDERS.find((provider) => provider.kind === kind)?.name ?? kind
  );
}
